import { useEffect } from 'react';

function listen(callBack: (payload: any) => void, channel: string, event: string) {
  console.log(`Call event: ${event} on Channel: ${channel}`);
  window.Echo.private(channel)
    .listen(event, (payload: any) => {
      callBack(payload);
    });

  // Função de limpeza para sair do canal
  return function cleanUp() {
    window.Echo.leaveChannel(`private-${channel}`);
    console.log(`WebSocket connection closed for channel: private-${channel}`);
  };
}

export const useSocket = ({ callBack, channel, event }) => {
  useEffect(() => {
    const enabledEnv = process.env.REACT_APP_ENABLE_WEBSOCKETS;
    const socketsEnabled = enabledEnv === undefined ? true : enabledEnv.toLowerCase() === 'true';
    if (!socketsEnabled) {
      // WebSockets foram desabilitados via .env — não faz nada
      console.log('WebSockets disabled by REACT_APP_ENABLE_WEBSOCKETS');
      return;
    }

    if (!callBack || !channel || !event) return;
    if (!window?.Echo) {
      console.warn('Echo not initialized — skipping socket listen');
      return;
    }

    const cleanup = listen(callBack, channel, event);

    // Handler para fechar conexão ao fechar navegador/aba
    const handleBeforeUnload = () => {
      cleanup();
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Handler para erros de conexão
    const handleError = (e) => {
      console.error('WebSocket error:', e);
      cleanup();
    };
    window.Echo.connector.socket?.addEventListener?.('error', handleError);

    // Limpeza ao desmontar componente ou mudar dependências
    return () => {
      cleanup();
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.Echo.connector.socket?.removeEventListener?.('error', handleError);
    };
  }, [callBack, channel, event]);
};
